import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
// @material-ui/icons
import ExpandMore from "@material-ui/icons/ExpandMore";

import accordionStyle from "assets/jss/material-dashboard-pro-react/components/accordionStyle.jsx";

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    let active = props.active;
    if (active == null) {
      active = props.singleActive ? -1 : [];
    }
    this.state = {
      active: active
    };
  }

  handleChange = panel => (event, expanded) => {
    if (this.props.singleActive) {
      this.setState({
        active: expanded ? panel : -1
      });
    } else {
      let active = this.state.active;
      if (active.includes(panel)) {
        active.splice(active.indexOf(panel), 1);
      } else {
        active.push(panel);
      }
      this.setState({
        active: active
      });
    }
  };

  render() {
    const {
      classes,
      collapses,
      singleActive,
      expansionPanelProps,
      expansionPanelSummaryProps
    } = this.props;
    return (
      <div className={classes.root}>
        {collapses.map((prop, key) => {
          let expanded = singleActive ? this.state.active === key : this.state.active.includes(key);
          return (
            <ExpansionPanel
              expanded={expanded}
              onChange={this.handleChange(key)}
              key={key}
              classes={{
                root: classes.expansionPanel,
                expanded: classes.expansionPanelExpanded
              }}
              {...expansionPanelProps}
            >
              <ExpansionPanelSummary
                expandIcon={<ExpandMore/>}
                classes={{
                  root: classes.expansionPanelSummary,
                  expanded: classes.expansionPanelSummaryExpaned,
                  content: classes.expansionPanelSummaryContent,
                  expandIcon: classes.expansionPanelSummaryExpandIcon
                }}
                {...expansionPanelSummaryProps}
              >
                <h4 className={classes.title}>{prop.title}</h4>
                <h4 className={classes.secondaryTitle}>{prop.secondaryTitle}</h4>
                <span className={"actions"}>{prop.actions}</span>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails className={classes.expansionPanelDetails}>
                {typeof prop.content === "function" ? <prop.content expanded={expanded}/> : prop.content}
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
      </div>
    );
  }
}

Accordion.defaultProps = {
  singleActive: false
};

Accordion.propTypes = {
  classes: PropTypes.object.isRequired,
  // index of the default active collapse
  active: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number]
  ),
  collapses: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      secondaryTitle: PropTypes.string.isOptional,
      content: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.func
      ]),
      actions: PropTypes.node.isOptional
    })
  ).isRequired,
  singleActive: PropTypes.bool,
  expansionPanelProps: PropTypes.object,
  expansionPanelSummaryProps: PropTypes.object
};

export default withStyles(accordionStyle)(Accordion);
